import React, { PureComponent } from 'react';
import { Line } from 'rc-progress';
import { CloseBtn, FileBox } from 'src/components/basic';
import { DropProgressBox } from 'src/components/complex';

import { remCss, scssVariables } from 'src/helpers';

export class MediaDropProgressBox extends PureComponent {
  state = {
    updated: null
  };
  data = [];
  internalId;

  componentDidMount() {
    this.data = [];
    this.internalId = setInterval(() => {
      this.data = this.data.filter(
        (item) =>
          !(
            ['cancelled', 'done', 'error'].indexOf(item.progress.state) > -1 &&
            item.progress.time + 5000 < Date.now()
          )
      );
      this.setState({
        update: Date.now()
      });
    }, 5000);
  }

  componentWillUnmount() {
    this.internalId && clearInterval(this.internalId);
  }

  onDrop = (n, files) => {
    const { beforeUpload, multi } = this.props;
    if (!multi) files = [files[0]];
    beforeUpload ? beforeUpload(files, () => this.onUpload(files)) : this.onUpload(files);
  };

  onUpload = (files) => {
    this.data = [
      ...this.data,
      ...files.map((file) => {
        const item = {
          id: Date.now(),
          progress: {
            time: Date.now(),
            state: 'uploading',
            percent: 0
          },
          file
        };
        if (!file.onUploadProgress) file.onUploadProgress = [];
        file.onUploadProgress.push((state) => {
          this.update(item)(null, state.status !== 'sent' ? Math.max(1, state.progress - 1) : 100);
        });
        this.props.onUpload(file, this.update(item), this.complete(item));
        return item;
      })
    ];
    this.setState({ updated: Date.now() });
  };

  update = (target) => (e, progress) => {
    this.data = this.data.map((item) => {
      if (item.id !== target.id || item.progress.state === 'cancelled') return item;
      return {
        ...item,
        progress: {
          time: Date.now(),
          percent: progress,
          state: progress > 99 ? 'done' : 'uploading'
        }
      };
    });
    this.setState({
      updated: Date.now()
    });
  };

  complete = (target) => (err) => {
    this.data = this.data.map((item) => {
      if (item.id !== target.id) return item;
      if (err === 'no data received' && item.progress.state === 'cancelled') return item;
      return {
        ...item,
        progress: {
          time: Date.now(),
          percent: 100,
          state: err ? 'error' : 'done'
        }
      };
    });
    this.setState({
      updated: Date.now()
    });
  };

  remove = (target) => () => {
    if (
      ['cancelled', 'done', 'error'].indexOf(target.progress.state) > -1 &&
      target.progress.time + 300 < Date.now()
    ) {
      this.data = this.data.filter((item) => item.id !== target.id);
      this.setState({
        updated: Date.now()
      });
    }
    if (target.progress.state === 'uploading') {
      this.data = this.data.map((item) => {
        if (item.id !== target.id) return item;
        return {
          ...item,
          progress: {
            ...item.progress,
            time: Date.now(),
            state: 'cancelled'
          }
        };
      });
      this.setState({
        updated: Date.now()
      });
      target.file.request.cancel();
      if (target.file.cancelUpload) target.file.cancelUpload();
    }
  };

  render() {
    const { style = {}, template = 1, ...other } = this.props;

    return (
      <div
        className={'mc-flex-30-col mc-media-drop-progress-box template-' + template}
        style={style}
      >
        <DropProgressBox {...other} onDrop={this.onDrop} />
        {this.data.length > 0 && (
          <div className={'mc-flex-20-col'} style={{ alignItems: 'center' }}>
            {this.data.map((item, index) => (
              <div
                style={{ maxWidth: remCss(450) }}
                key={index}
                className={'mc-flex-20 mc-ptb20 mc-plr15 mc-bg-primary-light mc-radius-5 '}
              >
                <FileBox
                  template={2}
                  videoProps={{ controls: false, playsinline: true, muted: true }}
                  onFile={() => {}}
                  key={'mc-media-' + index}
                  file={{ ...item.file, onUploadProgress: null, uploadState: null }}
                  onClose={null}
                  styles={{
                    width: remCss(50),
                    height: remCss(50)
                  }}
                  showFileName={false}
                  onlyPreview={true}
                />
                <div className={'mc-flex-10-col mc-grow'} style={{ overflow: 'auto' }}>
                  <div className={'mc-flex mc-text-418'}>
                    <div className={'mc-text-truncate'}>
                      {item.file?.name || item.file?.originalName}
                    </div>
                    <div>-</div>
                    <div className={'mc-grow'}>{item.progress.state}</div>
                    <div>{item.progress.percent}%</div>
                    <CloseBtn onClose={this.remove(item)} width={25} style={{}} />
                  </div>
                  <Line
                    percent={item.progress.percent}
                    height={10}
                    width={'100%'}
                    strokeColor={scssVariables['colors-mc-primary']}
                    trailColor={'#fff'}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}
